import { PdfGen, PdfUnit, PdfSize, PdfRect } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

export class Tabulka implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 20;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage();
    const margin = PdfUnit.FromMillimeters(5);

    const itemCount = Math.min(opts.list.length, 20);
    const totalRows = 1 + itemCount;
    const { origin, size } = calcOrigin(1, totalRows, margin, PdfSize.A4);

    const items = opts.list.slice(0, itemCount);

    const leftTexts = items.map((item) => [item.left.getText() ?? '']);
    const rightTexts = items.map((item) => [item.right.getText() ?? '']);

    const colWidth = PdfUnit.FromMillimeters(40);
    const leftFont = page.adjustFontMulti(
      leftTexts,
      GUtil.baseFont,
      new PdfSize(colWidth, size.height)
    );
    const rightFont = page.adjustFontMulti(
      rightTexts,
      GUtil.baseFont,
      new PdfSize(colWidth, size.height)
    );

    for (let y = 0; y < totalRows; y++) {
      const index = y - 1;

      const rect = new PdfRect(origin.x, margin + y * size.height, size.width, size.height);
      const r1 = new PdfRect(rect.left, rect.top, colWidth, rect.height);
      const r2 = new PdfRect(r1.right, rect.top, colWidth, rect.height);
      const rx = new PdfRect(r2.right, rect.top, rect.right - r2.right, rect.height);

      if (y >= 1 && index < itemCount) {
        page.drawLabel(items[index].left, { rect: r1, font: leftFont });
        page.drawLabel(items[index].right, { rect: r2, font: rightFont });

        page.drawRectangle(GUtil.basePen, null, r1);
        page.drawRectangle(GUtil.basePen, null, r2);
      }

      page.drawRectangle(GUtil.basePen, null, rx);
    }
  }
}
